import { useCallback, useState } from 'react';

import type { Bonus2026FlyInTriggerWrapperProps } from './Bonus2026FlyInTriggerWrapper.types';

const Bonus2026FlyInTriggerWrapper = ({
    className,
    children,
}: Bonus2026FlyInTriggerWrapperProps) => {
    const [isError, setIsError] = useState(false);
    const handleError = useCallback(() => {
        setIsError(true);
    }, []);

    if (isError) {
        return null;
    }

    return <div className={className}>{children(handleError)}</div>;
};

export default Bonus2026FlyInTriggerWrapper;
